import { Component, OnInit} from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { DynamicBarService} from '../../../_components/dynamic-bar/dynamic-bar.service';
import { Unidad} from '../../../_models/unidad';
import { EstudioService} from '../estudio.service';
import { MetaUnidad} from '../../../_models/meta-unidad';
import { UnidadEtapasService} from '../unidad-etapas/_services/unidad-etapas.service';
import { RubricaComponent} from '../unidad-etapas/rubrica/rubrica.component';
import { MatDialog } from '@angular/material/dialog';
import { Location} from '@angular/common';
import { AccountService} from "../../../_services/account.service";
import { GLMLanguageService } from 'src/app/_services/glm-language.service';
import { AutoevaluacionService } from '../autoevaluacion/autoevaluacion.service';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'unidad-familia',
  standalone: false,
  templateUrl: 'unidad-familia.component.html',
  styleUrls: ['../unidad-etapas/unidad-etapas-metas/unidad-etapas-metas.component.scss']
})

export class UnidadFamiliaComponent implements OnInit {

  unidad;
  categorias;
  eventoCategorias;
  metasRCategorias = [];
  alumnoId: number;

  showMetasReferencia = false;

  metas: any[] = [];

  showEvidencias = false;

  constructor(private location: Location,
              private route: ActivatedRoute,
              private dynamicBarService: DynamicBarService,
              private estudioService: EstudioService,
              private unidadEtapasService: UnidadEtapasService,
              public matDialogRef: MatDialog,
              public accountService: AccountService,
              public languageService: GLMLanguageService,
              private autoevaluacionService: AutoevaluacionService) {
  }

  ngOnInit() {
    this.dataInit();
  }

  dataInit() {
    const user = this.accountService.getUser();
    if (user && user.rol.indexOf('Alumno') > 1) {
      this.showEvidencias = true;
    }

    this.showEvidencias = true;

    this.route.data.subscribe((data: { categorias }) => {
      this.categorias = data.categorias;
      const categoriasR = this.categorias.filter(cat => +cat.ordenAgrupador === 4);
      categoriasR[0].categorias.map(subCat => {
        this.metasRCategorias.push(+subCat.id);
      });
    });
    const unidadID = this.route.snapshot.paramMap.get('id');
    this.alumnoId = +this.route.parent.snapshot.paramMap.get('hijoID');

    this.estudioService.getUnidadMetas(unidadID, this.alumnoId).subscribe((res) => {
        this.languageService.setLanguage({nickName: res['idioma']});
        this.unidad = new Unidad(this.estudioService.extractData(res));
        this.metas = this.unidad.metas.map(metaUnidad => {
          return new MetaUnidad(metaUnidad);
        });
        this.eventoCategorias = this.estudioService.extractData(res).eventosCategoria;
        this.dynamicBarService.setBarra('estudio-unidad-familia', { unidad: this.unidad });
    }, err => {

    });

    this.unidadEtapasService.getUnidadEtapasObservable().subscribe(data => {
      if (!data) {
        return;
      }
      if (data.tipo === 'abrir-dialogo') {
        this.abrirDialog(data.tipoObjeto, data.objeto);
      }
    });
  }

  onChangeTab(index) {
    const urlFrags = this.location.path(false),
      tab = (index === 0) ? '#metas' : (index === 1) ? '#evidencias' : (index === 2) ? '#rubrica' : '';

    this.location.go(`${urlFrags}${tab}`);

  }

  abrirDialog(tipo, objeto?) {
    let dialogo;
    if (tipo.indexOf('rubrica') > -1) {
      dialogo = this.matDialogRef.open(RubricaComponent, {
        width: '75%',
        // height: '55%',
        data: {
          rubrica: objeto
        }
      });
      dialogo.afterClosed().subscribe(() => {

      });
    }

  }
}
